module.exports = __webpack_public_path__ + "static/media/avatar.db0de70d.png";